import React, {Component} from 'react';
import Publisher from "../../../../containers/mmp/article/Publisher";
import {uuid} from "../../../../utils";

class RmPublisher extends Component {

    className = "a"+uuid();
    publisherKey = "a"+uuid();

    state = {};

    setData(record){
        this.publisherKey = "a"+uuid();
        this.setState({record});
    }

    getData(){
        return this.publisherComponent.getData();
    }

    render() {
        let publishType = this.state.record?.variableFields?.publishType;
        return (<div className={this.className} style={{fontSize:12}}>
                <Publisher key={this.publisherKey}
                           ref={publisherComponent=>this.publisherComponent = publisherComponent}
                           colon={false}
                           publishId={this.state.record?.variableFields?.publishId || this.state.record?.mediaId}
                           publishName={this.state.record?.variableFields?.publishName || this.state.record?.mediaName}
                           publishType={(publishType || publishType === 0) ? publishType : this.state.record?.rmType}
                           permission={this.state.record?.variableFields?.permission}
                           publishPhoto={this.state.record?.variableFields?.publishPhoto}
                />
                <style>{`
                            .${this.className} .ant-form-item{
                                font-size: 12px !important;
                                margin-bottom: 0px !important;
                            }
                            
                            .${this.className} .ant-form-item-label > label{
                                color: #000000a6 !important;
                            }
                       `}</style>
            </div>
        );
    }
}

export default RmPublisher;
